import Vue from 'vue'
import IconTips from '../components/common/popView/IconTips'
import MtgFormItem from '../components/forms/MtgFormItem'

export default () => {
  Vue.component('icon-tips', IconTips)
  Vue.component('mtg-form-item', MtgFormItem)
}
